module.exports = __webpack_public_path__ + "static/Felis-W1-948a9ad397e07808c85f049e172d5782.webp";